import request, { serviceV2 } from '@/utils/request'
import { HM_FORM_STATUS, HM_QUESTIONNAIRE_STATUS } from '@/constant/questionnaire'

const prefix = '/django_rest/questionnaire'
const hmPrefix = '/hm-questionnaire'
const hmScaleConfigPrefix = `${hmPrefix}/score-scale-config`

export default {

  checkQuestionnairePermission: (invitationId) => {
    return request.get(`${prefix}/check-permission`, { params: { invitation_id: invitationId } })
  },

  getInvitationInfo: (invitationId) => {
    return request.get(`${prefix}/invitation/${invitationId}`)
  },

  checkQuestionnaireInvitationCode: ({ invitationCode }) => {
    return request.get(`${prefix}/check-invitation-code`, { params: { invitation_code: invitationCode } })
  },

  getQuestionnaireSteps: (questionnaireId) => {
    return request.get(`${prefix}/step/${questionnaireId}`)
  },

  getStepQuestions: ({ questionnaireId, stepId, invitationId }) => {
    return request.get(`${prefix}/question/${stepId}`, { params: { questionnaire_page_id: questionnaireId, invitation_id: invitationId } })
  },

  answerQuestions: ({ questionnaireId, answers, isLastPage, invitationCode }) => {
    return request.post(`${prefix}/answer`, { questionnaire_page_id: questionnaireId, answers: answers, is_last_page: isLastPage, invitation_code: invitationCode })
  },

  getQuestionnaireWeChatSpread: (invitationId) => {
    return request.get(`${prefix}/wechat/spread/${invitationId}/`)
  },

  searchHmQuestions (params = {}) {
    return serviceV2.get(`${hmPrefix}/questions/`, { params })
  },

  getHmQuestionById (id) {
    return serviceV2.get(`${hmPrefix}/questions/${id}/`)
  },

  createHmQuestion (payload) {
    return serviceV2.post(`${hmPrefix}/questions/`, payload)
  },

  updateHmQuestion ({ id, payload }) {
    return serviceV2.put(`${hmPrefix}/questions/${id}/`, payload)
  },

  updateHmQuestionStatus ({ id, status }) {
    return serviceV2.post(`${hmPrefix}/questions/${id}/${status === HM_QUESTIONNAIRE_STATUS.ENABLED ? 'enable' : 'disable'}/`)
  },

  getHmScoreScaleConfig () {
    return serviceV2.get(`${hmScaleConfigPrefix}/`)
  },

  updateHmScoreScaleConfig (payload) {
    return serviceV2.put(`${hmScaleConfigPrefix}/`, payload)
  },

  searchHmQuestionnaires (params = {}) {
    return serviceV2.get(`${hmPrefix}/questionnaires/`, { params })
  },

  getHmQuestionnaireById (id) {
    return serviceV2.get(`${hmPrefix}/questionnaires/${id}/`)
  },

  createHmQuestionnaire (payload) {
    return serviceV2.post(`${hmPrefix}/questionnaires/`, payload)
  },

  updateHmQuestionnaire ({ id, payload }) {
    return serviceV2.put(`${hmPrefix}/questionnaires/${id}/`, payload)
  },

  copyHmQuestionnaire (id) {
    return serviceV2.post(`${hmPrefix}/questionnaires/${id}/copy/`)
  },

  updateHmQuestionnaireStatus ({ id, status }) {
    return serviceV2.post(`${hmPrefix}/questionnaires/${id}/${status === HM_FORM_STATUS.OPEN ? 'enable' : 'disable'}/`)
  },

  validateHmQuestionnaireName (params) {
    return serviceV2.get(`${hmPrefix}/questionnaires/validate/name/`, { params })
  }
}
